<section class="mb-4 shadow border bg-white rounded-3">
  <nz-account-settings [profile]="profile"/>
</section>
<section class="mb-4 shadow border bg-white rounded-3 overflow-hidden">
  <nz-notification-settings/>
</section>
<section class="mb-4 shadow border bg-white rounded-3">
  <nz-blocked-users/>
</section>
<section class="shadow border bg-white rounded-3">
  <nz-delete-account/>
</section>
